/* Lista de produtos da Anasol (03/10, preview aprovado), só no modelo collection.weup-anasol-colecao. Só aparência e
   atalhos: filtros, ordenação, paginação, favoritos e a sacola continuam os do tema (modal-panel, filter-field,
   buy-button). Aqui: o painel de filtros começa fechado (o tema abre no desktop), um véu fecha ele, os atalhos de
   cada filtro abrem o painel no filtro certo, a contagem, "Ler mais" no texto do topo, a barra fixa do celular e,
   em cada cartão, "Uso diurno" escrito (do ícone do tema) e o selo de FPS (do nome do produto). */
(function () {
  "use strict";
  var celular = function () { return window.innerWidth < 768; };

  function topo() {
    var t = document.querySelector(".an-colecao-topo"); if (!t) return null;
    var texto = t.querySelector(".an-colecao-texto"), ler = t.querySelector(".an-colecao-ler");
    if (texto) [].slice.call(texto.querySelectorAll("br")).forEach(function (br) { var e = document.createElement("span"); e.className = "an-br-espaco"; e.textContent = " "; br.before(e); });
    if (texto && ler) {
      var mede = function () { texto.classList.remove("aberto"); ler.hidden = texto.scrollHeight <= texto.clientHeight + 2; };
      mede();
      ler.addEventListener("click", function () { var a = texto.classList.toggle("aberto"); ler.textContent = a ? "Ler menos" : "Ler mais"; ler.setAttribute("aria-expanded", a ? "true" : "false"); });
    }
    return t;
  }

  /* Busca (05/10): o termo entre aspas tipográficas (a Ranille desenha a aspa reta como de fechamento) e sem a sintaxe
     da busca que o cabeçalho da Anasol acrescenta (vendor:, title:, AND). */
  function termo() {
    var t = document.querySelector(".filterable-grid__search-term"); if (!t) return;
    var limpo = t.textContent.replace(/\bvendor:\S+/gi, " ").replace(/\b(title|tag|product_type):/gi, "").replace(/\b(AND|OR)\b/g, " ")
      .replace(/[()"]/g, "").replace(/\s+/g, " ").trim();
    t.textContent = "“" + limpo + "”";
  }

  function painel() { return document.querySelector(".filterable-grid__filter-modal"); }
  function abre(grupo) {
    var p = painel(); if (!p) return;
    if (!p.classList.contains("open")) p.open ? p.open() : p.classList.add("open");
    if (grupo) { var d = grupo.querySelector("details"); if (d) d.open = true; setTimeout(function () { grupo.scrollIntoView({ block: "start", behavior: "smooth" }); }, 250); }
  }
  function fecha() { var p = painel(); if (p && p.classList.contains("open")) p.close ? p.close() : p.classList.remove("open"); }

  function barra(t) {
    var cab = document.querySelector(".filterable-grid__header"); if (!cab || cab.dataset.anPronto) return; cab.dataset.anPronto = "1";
    var direita = cab.querySelector(".filterable-grid__header-right");
    // atalhos: um por filtro do tema, com o nome dele
    var atalhos = document.createElement("div"); atalhos.className = "an-colecao-atalhos";
    [].slice.call(document.querySelectorAll(".filterable-grid__filter-group")).forEach(function (g) {
      var nome = g.querySelector(".filterable-grid__filter-name, summary"); if (!nome) return;
      var b = document.createElement("button"); b.type = "button"; b.className = "an-colecao-atalho";
      b.textContent = nome.textContent.replace(/\s+/g, " ").trim();
      b.addEventListener("click", function () { abre(g); }); atalhos.appendChild(b);
    });
    var toggle = cab.querySelector(".filterable-grid__filter-toggle");
    if (toggle) toggle.after(atalhos); else cab.prepend(atalhos);
    if (t && direita) {
      var n = +t.dataset.total || 0, c = document.createElement("span"); c.className = "an-colecao-contagem";
      c.textContent = n + " " + (n === 1 ? (t.dataset.unidade || "produtos").replace(/s$/, "") : (t.dataset.unidade || "produtos"));
      direita.prepend(c);
    }
    // celular: Filtrar e Ordenar numa barra fixa embaixo
    var fixa = document.createElement("div"); fixa.className = "an-colecao-barra";
    fixa.innerHTML = '<button type="button" class="an-colecao-filtrar">Filtrar</button><button type="button" class="an-colecao-ordenar">Ordenar</button>';
    fixa.querySelector(".an-colecao-filtrar").addEventListener("click", function () { abre(); });
    fixa.querySelector(".an-colecao-ordenar").addEventListener("click", function () {
      var s = document.querySelector(".filterable-grid__sort-select"); if (!s) return;
      s.scrollIntoView({ block: "center" }); s.focus(); if (s.showPicker) { try { s.showPicker(); } catch (e) {} }
    });
    document.body.appendChild(fixa);
  }

  function veu() {
    var p = painel(); if (!p || document.querySelector(".an-colecao-veu")) return;
    var v = document.createElement("div"); v.className = "an-colecao-veu"; v.addEventListener("click", fecha); document.body.appendChild(v);
    var liga = function () { var on = p.classList.contains("open"); v.classList.toggle("ativo", on); document.documentElement.classList.toggle("an-colecao-filtros", on); };
    new MutationObserver(liga).observe(p, { attributes: true, attributeFilter: ["class"] });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") fecha(); });
    // o tema abre os filtros no desktop ao carregar: aqui começam fechados
    var tenta = 0, fechaNoInicio = function () { if (p.classList.contains("open")) fecha(); if (++tenta < 6) setTimeout(fechaNoInicio, 150); };
    fechaNoInicio(); liga();
  }

  function cartoes(raiz) {
    [].slice.call((raiz || document).querySelectorAll(".filterable-grid__product-item product-card:not([data-an-pronto])")).forEach(function (card) {
      card.dataset.anPronto = "1";
      var titulo = card.querySelector(".product_title"), corpo = titulo && titulo.parentElement;
      var icones = [].slice.call(card.querySelectorAll(".product-icons img[alt]"));
      icones.forEach(function (i) {
        var nome = i.alt.replace(/^\s*ícone\s*/i, "").trim(); if (!nome || !corpo) return;
        var s = document.createElement("span"); s.className = "an-colecao-uso"; s.textContent = nome.charAt(0).toUpperCase() + nome.slice(1);
        corpo.insertBefore(s, titulo);
      });
      var fps = titulo && /FPS\s*(\d+)/i.exec(titulo.textContent), img = card.querySelector(".product-image");
      var kit = titulo && /\bkit\b/i.test(titulo.textContent);
      if (fps && img && !kit) { var b = document.createElement("span"); b.className = "an-colecao-fps"; b.innerHTML = "<small>FPS</small>" + fps[1]; img.appendChild(b); }
    });
  }

  /* Ordenar e filtrar: o tema muda o endereço mas não troca a grade (defeito que já existe na coleção do ar, 03/10).
     Aqui a página recarrega com o endereço que o tema montou, e o servidor entrega a grade já ordenada/filtrada. */
  window.anColecaoRecarrega = function () { location.reload(); };
  function recarga() {
    var sel = document.querySelector(".filterable-grid__sort-select");
    if (sel) sel.addEventListener("change", function () { setTimeout(function () { window.anColecaoRecarrega(); }, 450); });
    var p = painel(), antes = location.href;
    if (p) new MutationObserver(function () {
      if (p.classList.contains("open")) { antes = location.href; return; }
      setTimeout(function () { if (location.href !== antes) window.anColecaoRecarrega(); }, 450);
    }).observe(p, { attributes: true, attributeFilter: ["class"] });
  }

  function inicia() {
    var t = topo(); termo(); barra(t); veu(); cartoes(); recarga();
    var lista = document.querySelector(".filterable-grid");
    if (lista) new MutationObserver(function () { cartoes(lista); }).observe(lista, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", inicia); else inicia();
})();
